import React, { useState } from 'react';
import dayjs from 'dayjs';
import styles from './Calendar.module.css';

const Calendar = ({ salesData = {}, onFetchData }) => {
  const now = dayjs();
  const [currentDate, setCurrentDate] = useState(now);

  const year = currentDate.year();
  const month = currentDate.month() + 1;

  // --- 날짜 범위 계산 및 부모에게 데이터 요청 ---
  const triggerDataFetch = (date) => {
    if (typeof onFetchData === 'function') {
      // 이번 달 1일 00:00:00
      const startISO = date.startOf('month').format('YYYY-MM-DDTHH:mm:ss');
      // 다음 달 1일 00:00:00 (endLocalDateTime)
      const endISO = date.add(1, 'month').startOf('month').format('YYYY-MM-DDTHH:mm:ss');
      
      onFetchData(startISO, endISO);
    }
  };

  const handlePrevMonth = () => {
    const newDate = currentDate.subtract(1, 'month');
    setCurrentDate(newDate);
    triggerDataFetch(newDate); // 월 변경 시 호출
  };

  const handleNextMonth = () => {
    if (currentDate.isBefore(now, 'month')) {
      const newDate = currentDate.add(1, 'month');
      setCurrentDate(newDate);
      triggerDataFetch(newDate); // 월 변경 시 호출
    }
  };

  // 캘린더 계산 로직 (기존과 동일)
  const firstDayOfMonth = currentDate.startOf('month');
  const daysInMonth = currentDate.daysInMonth();
  const startDayColumn = firstDayOfMonth.day();

  const days = [];
  for (let i = 0; i < startDayColumn; i++) days.push(null);
  for (let i = 1; i <= daysInMonth; i++) days.push(i);
  
  const totalCells = 42; 
  while (days.length < totalCells) days.push(null);

  const daysOfWeek = ['일', '월', '화', '수', '목', '금', '토'];
  const isFuture = !currentDate.isBefore(now, 'month');

  return (
    <section className={styles.calendarCard}>
      <div className={styles.calendarHeader}>
        <h3 className={styles.cardTitle}>
          {year}년 {String(month).padStart(2, '0')}월 매출 캘린더
        </h3>
        <div className={styles.calendarNav}>
          <button className={styles.navBtn} onClick={handlePrevMonth}>
            {"<"}
          </button>
          <button 
            className={`${styles.navBtn} ${isFuture ? styles.disabled : ''}`} 
            onClick={handleNextMonth}
            disabled={isFuture}
          >
            {">"}
          </button>
        </div>
      </div>
      
      <div className={styles.calendarGrid}>
        {daysOfWeek.map(d => (
          <div key={d} className={styles.dayOfWeek}>{d}</div>
        ))}
        
        {days.map((date, i) => {
          if (date === null) {
            return <div key={`empty-${i}`} className={styles.emptyCell} />;
          }
          
          const dateKey = `${year}-${String(month).padStart(2, '0')}-${String(date).padStart(2, '0')}`;
          const amount = salesData[dateKey];
          const isToday = dayjs().format('YYYY-MM-DD') === dateKey;

          return (
            <div 
              key={`${dateKey}-${i}`} 
              className={`${styles.dateCell} ${isToday ? styles.today : ''}`}
            >
              <span className={styles.dateNum}>{date}</span>
              {amount !== undefined && amount !== null && (
                <span className={styles.dateAmount}>
                  {amount >= 10000 
                    ? `${(amount / 10000).toFixed(1)}만` 
                    : `${amount.toLocaleString()}`}
                </span>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Calendar;